// extracted by mini-css-extract-plugin
export default {"account":"MyAccount__account--2FB","icon":"MyAccount__icon--2CS","welcome":"MyAccount__welcome--28O","welcomeMessage":"MyAccount__welcomeMessage--11H"};